import {HistoriqueDossierComponent} from "./entete/historique/historique-dossier.component";
import {ListDocumentsComponent} from "./list-documents/list-documents.component";
import {TranslateService} from "@ngx-translate/core";
import {ArianeElement, ArianeStore} from "@digicerba/common";
import {DossierDto} from "@resources/resources";
import {ActivatedRoute} from "@angular/router";
import {Component, ViewChild} from "@angular/core";
import {DetectBrowser} from "@common/browser/detect-browser";


@Component({
  selector: 'detail-resultat',
  templateUrl: './detail-resultat.component.html',
  host: { 'class': 'page' }
})
export class DetailServeurResultatsComponent {

  @ViewChild('dossierListDocuments') dossierListDocuments: ListDocumentsComponent;
  @ViewChild('dossierHistorique') dossierHistorique: HistoriqueDossierComponent;

  dossier: DossierDto;
  hprimEnabled: true;
  reemissionEnabled: true;

  constructor(private arianeStore: ArianeStore, private activateRoute: ActivatedRoute, private translateService: TranslateService) {
  }

  ngOnInit() {
    this.activateRoute.data.subscribe((data) => {
      this.dossier = data.dossier;
      this.initFileAriane(this.dossier);
      this.hprimEnabled = data.hprimEnabled;
      this.reemissionEnabled = data.reemissionEnabled;
    });
  }

  public isHprimEnabled(): Boolean {
    return this.hprimEnabled;
  }

  public isReemissionEnabled(): Boolean {
  return this.reemissionEnabled;
}

  private initFileAriane(dossier: DossierDto) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANE.SERVEUR-RESULTATS",
        route: "/"
      },
      {
        libelle: this.translateService.instant("ARIANE.DOSSIER", {identifiant: dossier.identifiant}),
        route: "/detail-resultat/" + dossier.id
      }
    ]
    this.arianeStore.updateElements(arianeElements);
  }

  //Rajouter ici dans le cas où des utilisateurs auraient mis cette page sur un id en particulier en favoris
  isInternetExplorer(): boolean {
    return DetectBrowser.isInternetExplorer();
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/detail-resultat.component.ts